var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "url(#paint0_linear_4419_239158)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1525 25.6747V17.761H12.4766V14.6769H15.1525V12.4024C15.1525 9.76294 16.7723 8.32568 19.1382 8.32568C20.2715 8.32568 21.2455 8.40966 21.5294 8.44719V11.2056L19.8885 11.2064C18.6018 11.2064 18.3527 11.8149 18.3527 12.7078V14.6769H21.4213L21.0218 17.761H18.3526V25.6747H15.1525Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4419_239158",
    x1: 0,
    y1: 17,
    x2: 34,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7c57a3517e69e7e7fef94f17fad110de.svg";
export { ForwardRef as ReactComponent };